// ABOUTME: The four-state interview status badge (Analyzed / No evidence / Processing / Failed)
// ABOUTME: Text labels always (never color alone); pulse is static under prefers-reduced-motion

import { Job } from '@/api/ingestion'
import { InterviewSummary } from '@/api/interviews'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

export type InterviewStatus = 'processing' | 'failed' | 'analyzed' | 'no-evidence'

export function deriveStatus(
  row: Pick<InterviewSummary, 'evidence_count'>,
  activeJob: Job | undefined,
  latestJob: Job | undefined,
): InterviewStatus {
  if (activeJob) return 'processing'
  if (latestJob?.status === 'failed') return 'failed'
  return row.evidence_count > 0 ? 'analyzed' : 'no-evidence'
}

export function StatusBadge({ status, error }: { status: InterviewStatus; error?: string | null }) {
  if (status === 'processing') {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full bg-blue-100 text-blue-700">
        <span className="w-1.5 h-1.5 rounded-full bg-blue-600 animate-pulse motion-reduce:animate-none" />
        Processing
      </span>
    )
  }
  if (status === 'failed') {
    const badge = (
      <span className="inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full bg-red-100 text-red-700">
        Failed
      </span>
    )
    if (!error) return badge
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button aria-label={`Job failed: ${error}`}>{badge}</button>
          </TooltipTrigger>
          <TooltipContent className="max-w-sm whitespace-pre-wrap">{error}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }
  if (status === 'analyzed') {
    return (
      <span className="inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full bg-alx-green/15 text-alx-blue">
        ● Analyzed
      </span>
    )
  }
  return (
    <span className="inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full bg-gray-200 text-gray-700">
      ○ No evidence
    </span>
  )
}
